import { useEffect, useRef } from 'react'
import useTimeline from '../../../modules/timeline/useTimeline'
import { EcommerceBannerPlacement } from '../types'

// The element type is a parameter because not every banner card is a div — Chewy's strip renders
// buttons. It defaults to a div, so existing callers are unaffected.
export function useBannerImpression<T extends HTMLElement = HTMLDivElement>(
  productId: string,
  placement: EcommerceBannerPlacement | null,
  source?: string
) {
  const timeline = useTimeline()
  const elementRef = useRef<T>(null)
  const hasLogged = useRef(false)

  useEffect(() => {
    if (!placement || !elementRef.current || hasLogged.current) return

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !hasLogged.current) {
            hasLogged.current = true
            timeline.log({
              type: 'banner_impression',
              ref: productId,
              context: 'product_page' === placement ? { placement, source } : { placement }
            })
          }
        })
      },
      {
        threshold: 0.75, // Log when 75% of the banner is visible
        rootMargin: '0px'
      }
    )

    observer.observe(elementRef.current)

    return () => {
      observer.disconnect()
    }
  }, [productId, placement, source, timeline])

  return elementRef
}
